import React, { useMemo } from 'react';

export function useTableColumns({
    onActiveClientClick,
    onInactiveClientClick,
    onActiveAppIdTokenClick,
    onInactiveAppIdTokenClick,
} = {}) {

    function getClickableCountCell(value, onClick) {
        const count = Number(value) || 0;

        if (count <= 0 || typeof onClick !== "function") {
            return <div className="text-center">{count}</div>;
        }

        return (
            <div className="text-center">
                <button
                    type="button"
                    className="api-usage-report__count-link"
                    onClick={(event) => {
                        event.stopPropagation();
                        onClick();
                    }}
                >
                    {count}
                </button>
            </div>
        );
    }

    const columns = useMemo(() => [
        {
            Header: "Company ID",
            accessor: "CompanyId",
            id: "companyId",
            Cell: ({ value }) => {
                return <div className="text-left">{value || "-"}</div>;
            }
        },
        {
            Header: "Number of Client IDs (New)",
            accessor: "NumberOfClientId",
            id: "numberOfClientId",
            Cell: ({ value }) => {
                return <div className="text-center">{value || 0}</div>;
            }
        },
        {
            Header: "Number of Active Client IDs",
            accessor: "NumberOfActiveClientId",
            id: "numberOfActiveClientId",
            Cell: ({ value, row }) => {
                return getClickableCountCell(value, () => onActiveClientClick(row?.original));
            }
        },
        {
            Header: "Number of Inactive Client IDs",
            accessor: "NumberOfInactiveClientId",
            id: "numberOfInactiveClientId",
            Cell: ({ value, row }) => {
                return getClickableCountCell(value, () => onInactiveClientClick(row?.original));
            }
        },
        {
            Header: "Number of App ID Tokens (Old)",
            accessor: "NumberOfAppIdToken",
            id: "numberOfAppIdToken",
            Cell: ({ value }) => {
                return <div className="text-center">{value || 0}</div>;
            }
        },
        {
            Header: "Number of Active App ID Tokens",
            accessor: "NumberOfActiveAppIdToken",
            id: "numberOfActiveAppIdToken",
            Cell: ({ value, row }) => {
                return getClickableCountCell(value, () => onActiveAppIdTokenClick(row?.original));
            }
        },
        {
            Header: "Number of Inactive App ID Tokens",
            accessor: "NumberOfInactiveAppIdToken",
            id: "numberOfInactiveAppIdToken",
            Cell: ({ value, row }) => {
                return getClickableCountCell(value, () => onInactiveAppIdTokenClick(row?.original));
            }
        }
    ], [onActiveClientClick, onInactiveClientClick, onActiveAppIdTokenClick, onInactiveAppIdTokenClick]);

    return columns;
}
